let token: string;

// -------------------------------------
// Types
// -------------------------------------

export type StorageAPI = Pick<Storage, 'setItem' | 'getItem'>;

export enum TOKEN_STATUS {
  SUCCESS = 'SUCCESS'
}
// -------------------------------------
// Constants
// -------------------------------------

// Public sessionStorage key for the XCaliber token payload (slot name, not a secret).
// Keep as a literal: ui-common is pre-bundled for the browser; process.env is unavailable.
export const TOKEN_KEY = 'xcaliberToken';

// -------------------------------------
// API
// -------------------------------------
export const setItem = (key: string, tokenResponse: string) => {
  token = tokenResponse;
};

export const getItem = (key: string = TOKEN_KEY) => {
  return token;
};

export const clear = () => {
  token = undefined;
};

// -------------------------------------
// Typegaurd
// -------------------------------------
export const isXCaliberTokenResponse = (
  obj: any
): obj is CMxAPI.XCaliberTokenResponse => {
  return `status` in obj && `token` in obj && `tenantPath` in obj;
};
